/**
 * Clear filters + re-load content
 * @author Matt Haynes
 * @package TUoS
 *
 */


const ClearFilters = () => {
    const clearButton = document.getElementById('clear');
    if (!clearButton) return;
    const radios = document.querySelectorAll('.radio-container');
    const filterTitle = document.querySelector('.whatson__filters-title h2');

    clearButton.addEventListener('click', e => {
        e.preventDefault();

        window.history.pushState(null, null, '/whats-on/');
        // eslint-disable-next-line no-unused-vars

        radios.forEach(radio => {
            radio.classList.remove('active');
            // eslint-disable-next-line no-param-reassign
            radio.querySelector('input').checked = false;
        });
        radios[0].classList.add('active');
        radios[0].querySelector('input').checked = true;
        filterTitle.innerHTML = '<h2>Filter events</h2>';

        localStorage.setItem('from_date', '');
    });
};

export default ClearFilters;
